import Vue from 'vue';
import Select, { SelectOptions } from '@/components/Controls/Select';
import './LinksListWidget.scss';
import { JSONParser } from '@/utils/JSONParser';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';

interface LinksListWidgetProps {
    items: SelectOptions;
    active: string | null;
    threshold: number;
}

export function createLinksListWidget(el: Element) {
    const parser = new JSONParser('createLinksListWidget');
    const rootAttrs = new RootElementAttrsHolder(el);

    const items = el.getAttribute('data-items');
    const active = el.getAttribute('data-active');
    const threshold = el.getAttribute('data-threshold');

    const props: LinksListWidgetProps = {
        items: parser.parse<SelectOptions>(items),
        active,
        threshold: Number(threshold),
    };

    return new Vue({
        el,
        name: 'LinksListWidget',
        rootAttrs,
        data: {
            ...props,
            windowInnerWidth: 0,
        },
        render(h) {
            const desktop = (
                <div class="links-list__list">
                    {this.items.map((item) => {
                        return (
                            <a
                                href={item.value}
                                class={{
                                    'links-list__item': true,
                                    active: item.value === this.active,
                                }}
                            >
                                {item.label}
                            </a>
                        );
                    })}
                </div>
            );

            const mobile = (
                <Select
                    v-model={this.active}
                    options={this.items}
                    class="links-list__select"
                    onChange={(value: string) => {
                        window.location.href = value;
                    }}
                />
            );
            return (
                <div class="links-list">
                    {this.windowInnerWidth > this.threshold ? desktop : mobile}
                </div>
            );
        },
        methods: {
            updateWindowInnerWidth() {
                this.windowInnerWidth = window.innerWidth;
            },
        },
        created() {
            this.updateWindowInnerWidth();
            window.addEventListener('resize', this.updateWindowInnerWidth);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateWindowInnerWidth);
        },
    });
}
